<template>
  <apexchart
    :height="250"
    type="bar"
    :series="
      [{
          name: `${graphData.field_name}`,
          data: [...graphData.series]
        }]
    "
    :options="{
      chart: {
        id: `vuechart-${graph.id}`,
        zoom: {
          enabled: false
        },
        toolbar: {
          show: true,
          export: {
            csv: {
              filename: `${graph.name}`
            },
            svg: {
              filename: `${graph.name}`
            },
            png: {
              filename: `${graph.name}`
            }
          }
        }
      },
      plotOptions: {
        bar: {
          horizontal: horizontal || false,
        }
      },
      colors: [chartColor],
      xaxis: {
        categories: [...graphData.labels]
      }
    }"
    ref="apexChart"
  ></apexchart>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'Bar-Chart',
  props: ['graph', 'graphData', 'horizontal'],
  components: {
    apexchart: VueApexCharts
  },
  data ()  {
    return {
      chartColor: JSON.parse(localStorage.getItem('localization')).secondary_color
    }
  }
}
</script>
